<div class="modal-body">
    <h3 class="title">Submission successful!</h3>            
    <i class="fa-sharp fa-solid fa-circle-check"></i>
    <p>Your timesheet has been successfully submitted to your supervisor for approval.<br/>You don't need to do anything else.</p>
    <button type="button" class="btn btn-submission-successful" (click)="activeModal.close()">OK</button>
</div>
